export const API_ENDPOINT = 'https://api.cinuru.com';
// export const API_ENDPOINT = 'https://devapi.cinuru.com/dev';
//export const API_ENDPOINT = 'http://localhost:3000';
